const resumeImportMonitor = {
  title: '简历导入实时榜',
  subtitle: '按账号全量简历库统计，实时查看用户导入、清洗状态和最新动态。',
  windowLabel: '统计窗口',
  last24Hours: '近 24 小时',
  last72Hours: '近 72 小时',
  last7Days: '近 7 天',
  refresh: '刷新',
  liveConnected: '实时连接中',
  liveDisconnected: '实时连接断开',
  lastEvent: '最近事件 {time}',
  totalImported: '导入总数',
  completed: '清洗完成',
  processing: '处理中',
  pending: '待处理',
  failed: '失败',
  activeUsers: '导入用户',
  newUsers: '新注册用户',
  newUsersNote: '窗口内注册',
  topImporters: '导入排行榜',
  recentActivities: '实时导入动态',
  latestImports: '最近导入',
  noRanking: '暂无导入排名',
  noActivity: '暂无实时动态',
  unknownCandidate: '未知候选人',
  unknownUser: '未知用户',
  importedCount: '{count} 份',
  completedCount: '完成 {count}',
  state: {
    Pending: '待处理',
    Processing: '处理中',
    Completed: '已完成',
    Failed: '失败',
  },
  action: {
    imported: '导入',
    pending: '进入待处理',
    processing: '开始清洗',
    completed: '清洗完成',
    failed: '清洗失败',
  },
  activityText: '候选人 {candidate} 被 {user} {action}',
  streamError: '实时连接失败，已保留快照数据。',
}

export default resumeImportMonitor
